// Bottom-nav definitions per role. Imported by ClientLayout / CompanyLayout /
// WorkerLayout / AdminLayout and passed into DashboardLayout. Max 5 items per
// role keeps the bottom bar thumb-friendly. Items are intentionally a subset
// of the sidebar — the hamburger stays for the long tail.

import {
  type LucideIcon,
  LayoutDashboard,
  ClipboardList,
  Repeat,
  MessageCircle,
  User,
  Briefcase,
  CalendarRange,
  Users,
  Settings,
  Inbox,
  ListChecks,
  Wallet,
  CalendarCheck,
} from 'lucide-react'

export interface BottomNavItem {
  to: string
  icon: LucideIcon
  label: string
}

// Pure factories so labels can be re-translated (and lucide icons stay imported once).
export const clientBottomNav = (t: (k: string) => string): BottomNavItem[] => [
  { to: '/cont', icon: LayoutDashboard, label: t('bottomNav.home') },
  { to: '/cont/comenzi', icon: ClipboardList, label: t('bottomNav.bookings') },
  { to: '/cont/abonamente', icon: Repeat, label: t('bottomNav.subscriptions') },
  { to: '/cont/mesaje', icon: MessageCircle, label: t('bottomNav.chat') },
  { to: '/cont/setari', icon: User, label: t('bottomNav.account') },
]

export const companyBottomNav = (t: (k: string) => string): BottomNavItem[] => [
  { to: '/firma', icon: LayoutDashboard, label: t('bottomNav.home') },
  { to: '/firma/comenzi', icon: ClipboardList, label: t('bottomNav.orders') },
  { to: '/firma/program', icon: CalendarRange, label: t('bottomNav.calendar') },
  { to: '/firma/echipa', icon: Users, label: t('bottomNav.team') },
  { to: '/firma/setari', icon: Settings, label: t('bottomNav.settings') },
]

export const workerBottomNav = (t: (k: string) => string): BottomNavItem[] => [
  { to: '/worker', icon: CalendarCheck, label: t('bottomNav.today') },
  { to: '/worker/comenzi', icon: Briefcase, label: t('bottomNav.jobs') },
  { to: '/worker/program', icon: CalendarRange, label: t('bottomNav.schedule') },
  { to: '/worker/castiguri', icon: Wallet, label: t('bottomNav.earnings') },
  { to: '/worker/profil', icon: User, label: t('bottomNav.profile') },
]

export const adminBottomNav = (t: (k: string) => string): BottomNavItem[] => [
  { to: '/admin', icon: LayoutDashboard, label: t('bottomNav.home') },
  { to: '/admin/aprobari', icon: Inbox, label: t('bottomNav.queues') },
  { to: '/admin/comenzi', icon: ListChecks, label: t('bottomNav.ops') },
  { to: '/admin/utilizatori', icon: Users, label: t('bottomNav.data') },
  { to: '/admin/setari/platforma', icon: Settings, label: t('bottomNav.settings') },
]
